import { render, staticRenderFns } from "./customer-set-password.vue?vue&type=template&id=5138eb7c&"
import script from "./customer-set-password.vue?vue&type=script&lang=js&"
export * from "./customer-set-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports